/* eslint-disable jsdoc/check-tag-names */
import { Component, HostListener, Input, TemplateRef } from '@angular/core';
import { TooltipPosition } from '../tooltip/tooltip.enum';

/**
 * @usageNotes
 *
 * Basic popover:
 * <div u4Popover=[popoverMenu]>Hover me</div>
 *
 * <ng-template #popoverMenu>
 * Custom template in a popover!
 * </ng-template>
 */
@Component({
    selector: 'u4-popover',
    templateUrl: './popover.component.html',
    styleUrls: ['./popover.component.scss']
})
export class PopoverComponent {

    @Input() content: TemplateRef<any>;
    @Input() direction: TooltipPosition;

    @HostListener('document:keydown.escape')
    escapeKeyHandler() {
        document.body.click();
    }

}
